import { render, staticRenderFns } from "./statementOfCostsOnPersonnel.vue?vue&type=template&id=f6e00b9a&scoped=true&"
import script from "./statementOfCostsOnPersonnel.vue?vue&type=script&lang=js&"
export * from "./statementOfCostsOnPersonnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e00b9a",
  null
  
)

export default component.exports